import React from 'react';
import '../styles/404-page.css';

const NotFoundPage = () => {
  return (
    <div className="not-found-page-container">
      <h1>404</h1>
      <p>Oops! The page you're looking for doesn't exist.</p>
      <a className='btn primary-btn' href="/">Go Back Home</a>
    </div>
  );
};

export default NotFoundPage;
